import { render } from "./FooterView.vue?vue&type=template&id=a5b90d30&scoped=true"
const script = {}

import "./FooterView.vue?vue&type=style&index=0&id=a5b90d30&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b90d30"]])

export default __exports__